import { Box, Text, Flex } from '@chakra-ui/react';
import {
  Checkbox,
  Modal,
  TextArea,
  Button,
  useToast
} from '@morressier/alembic';
import { useState } from 'react';
import { FieldLabel } from 'src/components/Field';
import { AcknowledgeReport } from 'src/api/mutations';

interface Props {
  onClose: () => void;
  isOpen: boolean;
  submissionId: string;
  reportIds: string[];
}

const AcknowledgeModal = ({
  onClose,
  isOpen,
  submissionId,
  reportIds
}: Props) => {
  const [comment, setComment] = useState<string>('');
  const [checked, setChecked] = useState<boolean>(false);
  const { mutate, isPending } = AcknowledgeReport(submissionId);
  const toaster = useToast();
  const handleSubmit = () => {
    mutate(
      {
        comment,
        reportIds
      },
      {
        onSuccess: () => {
          setComment('');
          setChecked(false);
          onClose();
          toaster({
            title: 'Report Acknowledged',
            description: 'The report has been acknowledged successfully.',
            variant: 'success'
          });
        },
        onError: () => {
          toaster({
            title: 'Failed to Acknowledge Report',
            description:
              'An error occurred while acknowledging the report. Please try again.',
            variant: 'error'
          });
        }
      }
    );
  };

  return (
    <Modal width="45rem" onClose={onClose} isOpen={isOpen}>
      <Box padding={4}>
        <Box mb={4}>
          <Text textStyle={'headingItem'}>Acknowledge Report</Text>

          <Box textStyle={'textContext'}>
            Comment and acknowledge the selected reports
          </Box>
        </Box>

        <Flex flexDirection="column" gap={2}>
          <FieldLabel label={'Comment'} subText={''} isRequired={true} />

          <TextArea
            value={comment}
            id="comment"
            placeholder="Write the comment here"
            onChange={e => setComment(e.target.value)}
          />
        </Flex>

        <Box my={2}>
          <Checkbox
            isChecked={checked}
            onChange={e => setChecked(e.target.checked)}
            fontSize="sm"
            ariaLabel="Acknowledge_reports"
            name="AcknowledgeReports"
            id="AcknowledgeReports"
          >
            I have reviewed this report and understand that this will be logged
            for future use.
          </Checkbox>
        </Box>

        <Box width={'full'} mt={4}>
          <Box ml={'auto'} width={'max-content'}>
            <Button variant="secondary" mr={3} onClick={onClose}>
              Cancel
            </Button>

            <Button
              disabled={!comment.trim() || !checked}
              isLoading={isPending}
              onClick={handleSubmit}
            >
              Acknowledge reports
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AcknowledgeModal;
